'use client';

import Quote from '@/components/typography/quote';
import { useTranslation } from 'react-i18next';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <div className="mt-[54px] lg:mt-[77px]">
            <div className="flex min-h-[calc(6rem+77px)] flex-col items-center justify-center p-4 lg:min-h-[calc(16rem+77px)]">
                <div className="max-w-[1251px] text-center">
                    <h1 className="visually-hidden">${t('hero.h1')}</h1>
                    <Quote className="inline">{t('hero.text')} </Quote>
                    <Quote variant="italic" className="inline">
                        {t('hero.text2')}{' '}
                    </Quote>
                </div>
            </div>
        </div>
    );
}
